import { useQuery } from "@tanstack/react-query";
import apiService from "../services/api";
import { PatientMoodEntry } from "../types/api";

// Fetches the patient's last-30-days mood check-ins for the App tab.
// The backend already filters to the trailing 30 days and returns the list
// sorted by created_at.
export function usePatientMood(patientId: number | undefined, token: string) {
  const query = useQuery({
    queryKey: ["patient-mood-status", patientId],
    queryFn: () =>
      apiService.getPatientMoodStatus({
        token,
        patient_id: patientId!,
      }),
    enabled: !!patientId && !!token,
    staleTime: 1000 * 60 * 5, // 5 min
  });

  const entries: PatientMoodEntry[] = query.data ?? [];

  return {
    entries,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
